import React from 'react';
import { Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';
interface ICreate {
    onClick: () => void;
    title: string;
}
export function Create({ title, onClick }: ICreate) {
    return (
        <Button
            onClick={onClick}
            size="large"
            variant="contained"
            color="primary"
            data-component-name="CREATE_NEW_ITEM"
            startIcon={<Add />}
        >
            {title}
        </Button>
    );
}
